import ProfileRow from '../../../components/ProfileRow';
import useProfileData from '../../../hooks/useProfileData';

/**
 * EventRow - Displays event or prediction data using ProfileRow
 * Shows contact profile with image if available, otherwise shows event name
 * 
 * Used in 
 *  DayMenu => EventList
 *  DesktopDay => DayRow
 * 
 * Props:
 *   eventData: { title, subtitle, contact, date }
 *   predictionData: { ownerName, ownerImages, isActual }
 *   size: ProfileRow size ('xs', 'sm', 'md', 'lg')
 */
function EventRow({ eventData, predictionData, size = 'sm' }) {
  // Fetch contact profile from cache if eventData has a contact
  const { profile: contactProfile } = useProfileData(eventData?.contact);

  // Determine profile and subtitle based on data type
  let profile, subtitle, profileStyle;

  if (eventData) {
    const { title, subtitle: eventSubtitle } = eventData;
    if (contactProfile) {
      profile = contactProfile;
      subtitle = eventSubtitle || title || 'Event';
    } else {
      profile = { name: title || 'Event' };
      subtitle = eventSubtitle || undefined;
    }
    profileStyle = 'blue';
  } else if (predictionData) {
    const { ownerName, ownerImages, isActual } = predictionData;
    profile = { name: ownerName, images: ownerImages };
    subtitle = isActual ? 'Actual ovulation' : 'Pred OV';
    profileStyle = 'purple';
  }

  return (
    <ProfileRow
      profile={profile}
      subtitle={subtitle}
      size={size}
      profileStyle={profileStyle}
    />
  );
}

export default EventRow;
